import { SmartTable } from '@gisce/oficina-virtual-components'
import useTable from "./useTable"
import { useSettingsContext } from '@/components/Settings/hooks/useSettingsContext';
import PropTypes from "prop-types";

/**
 * @param {{ sortEnabled?: boolean } & Record<string, any>} props
 */
const Table = ({data, columns, loaded, onRowStatus, sortEnabled}) => {
  const Settings = useSettingsContext();
  const { rows } = useTable({loaded, columns, data});

  return (
    <SmartTable
      columns={columns}
      dataSource={rows ?? []}
      loading={false}
      onRowStatus={onRowStatus}
      loadingComponent={rows}
      sortEnabled={sortEnabled ?? Settings.features.smartTableSortEnabled}
    />
  )
}

Table.propTypes = {
  sortEnabled: PropTypes.bool,
}

export default Table;
